import { changelog } from '../../config';

export default function Changelog() {

    return (
        <div className="content-with-padding content-max changelog">
            <h2>Changelog</h2>
            <div className="card">
                <div className="card-body">
                    {changelog.releases.map(release =>
                        <div key={release.version}>
                            <h3>v{release.version} - {release.date}</h3>
                            <ul>
                                {release.changes.map((change, i) =>
                                    <li key={`${release.version}-${i}`}>{change.text}</li>
                                )}
                            </ul>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}